export default __webpack_public_path__ + "fe67728bff3783822104cfc6eb649bbd.svg";